export const getUserLocation = () => {
  return new Promise((resolve, reject) => {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const location = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          }
          resolve(location) // Resolve the Promise with the location
        },
        (err) => {
          reject('Unable to retrieve location. Error: ' + err.message) // Reject with an error message
        },
      )
    } else {
      reject('Geolocation is not supported by this browser.') // Reject if geolocation is not supported
    }
  })
}
